/* bios-netgraph.js — Network graph renderer (extracted from main-content.liquid)
   Called via window._biosInitNetGraph(_C) where _C is a context object
   providing accessor functions for outer-scope mutable variables.          */

window._biosInitNetGraph = function (_C) {
  /* ── Unpack read-only context ── */
  var origItems          = _C.origItems;
  var items              = _C.items;
  var MID                = _C.MID;
  var isTouchDevice      = _C.isTouchDevice;
  var illuminateAt       = _C.illuminateAt;
  var startSporadicType  = _C.startSporadicType;
  var cancelSporadicType = _C.cancelSporadicType;
  var playHoverSound     = _C.playHoverSound;
  var hideIdleView       = _C.hideIdleView;
  var showIdleView       = _C.showIdleView;
  var hidePreview        = _C.hidePreview;
  var showPreview        = _C.showPreview;
  var openOverlay        = _C.openOverlay;
  /* mutable outer vars — always access via _C getters/setters */

  if (isTouchDevice) return;
  var canvas   = document.getElementById('bios-netcanvas');
  var netfield = document.getElementById('bios-netfield');
  if (!canvas || !netfield) return;

  /* ── ASCII rendering helper ──────────────────────────────────────────
     Load an image and convert its pixels to a luminance-mapped ASCII
     grid. Cols × Rows chosen to match the node's aspect at the font
     size set in CSS (.bios-netnode-ascii — 6px line-height 1, mono
     char aspect ~0.6 W:H, so 60c × 36r ≈ a 216×216 block centred in
     the 260px node).

     Throttled with a tiny stagger so 20+ images don't all decode in
     the same frame on load. Shopify CDN serves images with CORS so
     getImageData works cross-origin; on the rare failure we fall
     back silently (ASCII layer stays empty → image shows through). */
  /* Ramp + grid scaled up alongside the bigger 380px node — 70×42 cells
     at font-size 9px = ~378×378 ASCII block, near-perfect fit. */
  var ASCII_RAMP = ' .,:;-~+=*';
  var ASCII_COLS = 70;
  var ASCII_ROWS = 42;
  var _asciiQ = 0;
  /* ── ASCII decryption animation ─────────────────────────────────────
     Hover handler calls decodeStart(asciiEl) on enter and decodeStop
     on leave. Reads as a real decryption sequence instead of a CSS
     clip-tear:
        - characters cycle rapidly through hex/binary/symbol noise
          (the system "trying" different keys)
        - scramble probability falls smoothly via a cosine curve
        - opacity holds at 1 for the first half, then fades
        - on completion, ASCII is invisible and the image underneath
          reads clearly
     On mouseleave (or interrupt), we restore the original ASCII and
     clear inline styles. prefers-reduced-motion gets a plain opacity
     crossfade — no character cycling. */
  var DECODE_GLITCH = '0123456789ABCDEF#@░▒▓?!ア▄▀%&'.split('');
  var DECODE_MS = 440;
  function decodeStart(asciiEl) {
    if (!asciiEl || asciiEl._decoding) return;
    asciiEl._decoding = true;
    if (!asciiEl._asciiOriginal) {
      asciiEl._asciiOriginal = asciiEl.textContent;
    }
    var original = asciiEl._asciiOriginal;
    if (!original) { asciiEl._decoding = false; return; }
    var reducedMotion = window.matchMedia &&
                        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      asciiEl.style.transition = 'opacity 0.30s ease';
      asciiEl.style.opacity = '0';
      return;
    }
    asciiEl.style.transition = 'none';
    var startTime = performance.now();
    function tick(now) {
      if (!asciiEl._decoding) return;
      var elapsed = now - startTime;
      var progress = Math.min(1, elapsed / DECODE_MS);
      if (progress >= 1) {
        asciiEl.style.opacity = '0';
        return;
      }
      /* Scramble probability — cosine wave from 1 → 0 across the
         duration. Heavy noise at start, settles toward end. */
      var scrambleP = (Math.cos(progress * Math.PI) + 1) * 0.5;
      /* Opacity holds full for the first 50% (showing the cycle),
         then linearly fades to 0. */
      asciiEl.style.opacity = progress < 0.5
        ? '1'
        : (1 - (progress - 0.5) / 0.5).toFixed(3);
      /* Rewrite characters in place — preserves layout because
         monospace chars + newlines line up identically. */
      var chars = original.split('');
      for (var i = 0; i < chars.length; i++) {
        var c = chars[i];
        if (c === ' ' || c === '\n') continue;
        if (Math.random() < scrambleP) {
          chars[i] = DECODE_GLITCH[Math.floor(Math.random() * DECODE_GLITCH.length)];
        }
      }
      asciiEl.textContent = chars.join('');
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function decodeStop(asciiEl) {
    if (!asciiEl) return;
    asciiEl._decoding = false;
    if (asciiEl._asciiOriginal) {
      asciiEl.textContent = asciiEl._asciiOriginal;
    }
    asciiEl.style.opacity = '';
    asciiEl.style.transition = '';
  }
  /* Expose decode helpers so bios-designer-mode.js can drive the same
     character-cycling animation from the centred title list hover (not
     just from netnode hover). Lets the title-hover state read as a
     full decrypt sequence instead of a plain opacity fade. */
  window._biosNetnodeDecode  = function (netnodeEl) {
    if (!netnodeEl) return;
    var ascii = netnodeEl.querySelector('.bios-netnode-ascii');
    if (ascii) decodeStart(ascii);
  };
  window._biosNetnodeRestore = function (netnodeEl) {
    if (!netnodeEl) return;
    var ascii = netnodeEl.querySelector('.bios-netnode-ascii');
    if (ascii) decodeStop(ascii);
  };

  function biosNetnodeAscii(src, targetEl) {
    var delay = _asciiQ * 18;            /* stagger 18ms per image */
    _asciiQ++;
    setTimeout(function () {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var c = document.createElement('canvas');
          c.width  = ASCII_COLS;
          c.height = ASCII_ROWS;
          var cc = c.getContext('2d');
          cc.drawImage(img, 0, 0, ASCII_COLS, ASCII_ROWS);
          var data = cc.getImageData(0, 0, ASCII_COLS, ASCII_ROWS).data;
          /* Single-colour amber rendering — characters chosen by
             luminance only. (Per-character RGB tinting was tried then
             reverted; the BIOS-amber feel was cleaner without colour
             bleed-through.) */
          var s = '';
          for (var y = 0; y < ASCII_ROWS; y++) {
            for (var x = 0; x < ASCII_COLS; x++) {
              var p = (y * ASCII_COLS + x) * 4;
              var l = 0.299 * data[p] + 0.587 * data[p+1] + 0.114 * data[p+2];
              var ri = Math.min(ASCII_RAMP.length - 1,
                                Math.floor((l / 256) * ASCII_RAMP.length));
              s += ASCII_RAMP.charAt(ri);
            }
            if (y < ASCII_ROWS - 1) s += '\n';
          }
          targetEl.textContent = s;
        } catch (e) {
          /* CORS or decode failure — leave the ASCII layer empty so
             the actual image shows through (degraded but functional). */
        }
      };
      img.onerror = function () { /* skip */ };
      img.src = src;
    }, delay);
  }

  var ctx = canvas.getContext('2d');
  var vw  = window.innerWidth;
  var vh  = window.innerHeight;
  canvas.width  = vw;
  canvas.height = vh;

  /* ── Scroll capture elements ── */
  var totalHeight = 0;

  var scrollerEl = document.createElement('div');
  scrollerEl.id = 'bios-net-scroller';
  netfield.parentNode.insertBefore(scrollerEl, netfield.nextSibling);

  var spacerEl = document.createElement('div');
  spacerEl.id = 'bios-net-spacer';
  scrollerEl.appendChild(spacerEl);

  /* ── Scroll suppression flag — prevents left-side illumination during scroll ── */
  var _netScrolling   = false;
  var _netScrollTimer      = null;
  var _netScrollRafId      = null;    /* rAF handle for smooth-scroll animation     */

  var _headerH = 0;                   /* measured header bottom, used for clipping  */
  var _footerH = 0;                   /* measured footer height, used for clipping  */
  function _markScrolling() {
    _netScrolling = true;
    clearTimeout(_netScrollTimer);
    _netScrollTimer = setTimeout(function () { _netScrolling = false; }, 350);
  }

  /* ── Clip-boundary glitch: fired when a node centre crosses header/footer line ── */
  function triggerBoundaryGlitch(nd) {
    if (nd.glitching) return;
    nd.glitching = true;
    var el = nd.el;
    /* step-flash: bright → dark → bright → restore */
    el.style.filter  = 'brightness(4) blur(1px)';
    el.style.opacity = '0.9';
    setTimeout(function () {
      el.style.filter  = 'brightness(0.04) blur(2px)';
      el.style.opacity = '0.06';
      setTimeout(function () {
        el.style.filter  = 'brightness(3)';
        el.style.opacity = '0.85';
        setTimeout(function () {
          el.style.filter  = '';
          el.style.opacity = '';
          nd.glitching = false;
        }, 55);
      }, 45);
    }, 35);
  }

  /* ── Pagination state (mirrors main-content.liquid) ── */
  var _ngPage       = 0;
  var _ngPageSize   = 5;
  var _ngWheelAccum = 0;

  /* Right-side wheel → dispatch page-next event (same transition as left side).
     Bail in designer-orbit mode (which includes catalog-orbit) — the orbit
     ring is a fixed constellation that shouldn't paginate when the center
     list is being scrolled. Without this, wheel events on the right side
     re-shuffle netnodes between pages, making the orbit appear to vanish
     and re-form on every scroll tick. */
  document.addEventListener('wheel', function (e) {
    if (netfield.classList.contains('is-designer-orbit')) return;
    if (e.clientX < window.innerWidth / 2) return;
    e.preventDefault();
    _ngWheelAccum += e.deltaY;
    if (Math.abs(_ngWheelAccum) > 50) {
      window.dispatchEvent(new CustomEvent('bios:page-next', {
        detail: { dir: _ngWheelAccum > 0 ? 1 : -1 }
      }));
      _ngWheelAccum = 0;
    }
  }, { passive: false });

  /* Show/hide nodes for the given page and reposition them within the
     header/footer safe zone so every node is FULLY visible on screen.
     Key fix: safe zone is computed per-node using nd.nodeSize/2 so the
     node's edges (not just its centre) are guaranteed to clear the
     header/footer clip boundary. We also add a breathing buffer (max
     vertical breath amplitude is ~17 px) so physics oscillation doesn't
     push a node edge back into a clipped area. */
  function renderPageNodes(page) {
    _ngPage = page;
    var start = page * _ngPageSize;
    var end   = Math.min(start + _ngPageSize, N);
    var count = end - start;

    var BREATH_BUF = 20;  /* ≥ max amY (7+10=17) to absorb breathing drift */
    var EDGE_PAD   = 8;   /* extra px between node edge and header/footer line */

    /* Orderly column on the right — matches layoutNodes() logic.
       BAND widened ±90 → ±160 so per-page nodes drift more organically
       (less stacked-on-top-of-each-other). */
    var centreLine = vw / 2 + (vw / 2) * 0.50;
    /* Wider horizontal drift, capped per viewport so nodes don't clip
       the right edge. ±18vw allows visible scatter on large screens
       (1440+) without overflow on smaller ones (~1280). */
    var BAND       = Math.min(Math.round(vw * 0.18), 280);

    /* Exclusion zones — mirror layoutNodes(). Pad +40px so drift doesn't
       creep into the music UI / right-side logstream. */
    var EXCL_PAD = 40;
    function rectOf(el) {
      if (!el) return null;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return null;
      return { l: r.left - EXCL_PAD, r: r.right + EXCL_PAD,
               t: r.top  - EXCL_PAD, b: r.bottom + EXCL_PAD };
    }
    var exclusions = [
      rectOf(document.querySelector('.bios-top-right')),  /* player + clock (top) */
      rectOf(document.getElementById('bios-logstream'))   /* right-side syslog */
      /* telemetry block removed — now lives in the manifest strip. */
    ].filter(Boolean);
    function shiftLeftOf(bx, by, halfSize) {
      for (var e = 0; e < exclusions.length; e++) {
        var z = exclusions[e];
        var nL = bx - halfSize, nR = bx + halfSize;
        var nT = by - halfSize, nB = by + halfSize;
        if (nR > z.l && nL < z.r && nB > z.t && nT < z.b) {
          bx = z.l - halfSize;
        }
      }
      return bx;
    }

    nodes.forEach(function (nd, i) {
      var visible = (i >= start && i < end);
      nd.el.style.display = visible ? '' : 'none';
      nd.pageIdx = visible ? (i - start) : -1;

      if (visible && count > 0) {
        var slot     = i - start;          /* 0-indexed within this page */
        var halfSize = nd.nodeSize / 2;    /* node radius in px           */

        /* Per-node safe band: centre must stay far enough from the clip
           boundary that the node's edges + breathing never get clipped. */
        var safeTop    = _headerH + halfSize + BREATH_BUF + EDGE_PAD;
        var safeBottom = vh - _footerH - halfSize - BREATH_BUF - EDGE_PAD;
        var safeHeight = Math.max(safeBottom - safeTop, 1);

        /* ── Inverted-C page layout ──────────────────────────────────
           When a page has the full 4 items, the first floats in the
           upper space above [NEW ARRIVALS], the last floats in the
           lower space below the last product title, and the middle
           two sit on the right side. Reads as a "⊃" / sideways-U
           with the opening facing left.

           Partial pages (1–3 items, e.g. the last page) ignore the
           inverted-C and centre items in the middle-right zone.

           Slot-to-zone mapping (count >= 4):
             slot 0          → TOP zone     (above [NEW ARRIVALS], bias left)
             slot count-1    → BOTTOM zone  (below last item, bias centre)
             everything else → MIDDLE-RIGHT (right column, more jitter) */
        var newBx, newBy;
        if (count >= 4 && slot === 0) {
          /* TOP zone — drift in upper area, biased slightly left
             (over the product-titles column area). Y at ~10% of safe
             height puts it well above [NEW ARRIVALS] (which sits at
             ~27% of drum height on typical viewports). */
          var topY  = safeHeight * 0.10;
          var topX0 = vw * 0.32;                              /* slightly left of centre */
          var topB  = Math.min(Math.round(vw * 0.18), 280);   /* drift band */
          newBy = safeTop + topY + (sRand(i * 7 + 3) - 0.5) * safeHeight * 0.06;
          newBx = topX0 + (sRand(i * 7 + 2) * 2 - 1) * topB;
        } else if (count >= 4 && slot === count - 1) {
          /* BOTTOM zone — drift in lower area, biased to the LEFT (mirrors
             the top slot's left bias, so the two endpoints of the C
             stack toward the same side of the viewport for a cleaner
             inverted-C silhouette). Y at ~90% of safe height puts it
             below the centred list. */
          var botY  = safeHeight * 0.90;
          var botX0 = vw * 0.30;                              /* slightly left of centre */
          var botB  = Math.min(Math.round(vw * 0.18), 280);
          newBy = safeTop + botY + (sRand(i * 7 + 3) - 0.5) * safeHeight * 0.05;
          newBx = botX0 + (sRand(i * 7 + 2) * 2 - 1) * botB;
        } else if (count >= 4) {
          /* MIDDLE-RIGHT — slots 1 .. count-2. Range widened from
             0.42-0.58 to 0.30-0.70 of safe height so the larger 320px
             nodes have more vertical separation. Horizontal lateral
             bias still adds diagonal distance between the middle pair. */
          var midIdx   = slot - 1;             /* 0-indexed within middle */
          var midCount = count - 2;            /* number of middle slots  */
          var midBase  = midCount > 1 ? midIdx / (midCount - 1) : 0.5;
          var midFrac  = 0.30 + midBase * 0.40;
          var midJit   = (sRand(i * 7 + 3) - 0.5) * 0.08;
          newBy = safeTop + (midFrac + midJit) * safeHeight;
          /* Wider BAND for "more jitter in the middle of the C". */
          var midBand   = Math.min(Math.round(vw * 0.22), 360);
          var biasSign  = (slot % 2 === 0) ? -1 : 1;
          var biasAmt   = midBand * 0.20;
          newBx = centreLine + biasSign * biasAmt
                  + (sRand(i * 7 + 2) * 2 - 1) * (midBand * 0.8);
        } else {
          /* Partial page (1–3 items) — centre cluster in the right
             column. Uses the previous compressed-middle layout. */
          var baseFraction = count === 1 ? 0.5 : slot / (count - 1);
          var compressed   = 0.30 + baseFraction * 0.40;     /* centre 40% */
          var partJit      = (sRand(i * 7 + 3) - 0.5) * (count > 1 ? 0.18 / (count - 1) : 0);
          var fraction     = Math.max(0.05, Math.min(0.95, compressed + partJit));
          newBy = safeTop + fraction * safeHeight;
          var pBiasSign = (slot % 2 === 0) ? -1 : 1;
          var pBiasAmt  = BAND * 0.35;
          newBx = centreLine + pBiasSign * pBiasAmt
                  + (sRand(i * 7 + 2) * 2 - 1) * (BAND * 0.7);
        }

        /* Always shift clear of music UI / logstream exclusion zones. */
        newBx = shiftLeftOf(newBx, newBy, halfSize);

        /* Update base position and zero physics so nodes settle cleanly */
        nd.bx = newBx;
        nd.by = newBy;
        nd.rx = 0; nd.ry = 0;
        nd.vx = 0; nd.vy = 0;
        nd.x  = newBx; nd.y = newBy;

        /* Write absolute position to DOM (RAF translate() is additive) */
        nd.el.style.left = Math.round(nd.bx - halfSize) + 'px';
        nd.el.style.top  = Math.round(nd.by - halfSize) + 'px';
      }
    });

    /* Zero the virtual scroller — nodes are in screen coords so any
       non-zero scrollTop in the RAF translate() would shift them off screen */
    scrollerEl.scrollTop = 0;
  }

  /* Listen for page-change event dispatched by main-content.liquid */
  window.addEventListener('bios:page-change', function (e) {
    _ngPageSize = e.detail.pageSize || _ngPageSize;
    /* Tear down any active node-hover before rendering the new page's nodes,
       otherwise the canvas lines from the previous hover persist. */
    if (_nodeHoverActive) {
      _nodeHoverActive = false;
      var _prevHover = _C.getHoverItem();
      if (_prevHover) {
        cancelSporadicType(_prevHover);
        hidePreview();
      }
      _C.setHoverItem(null);
      window._clearNetActive();
    }
    renderPageNodes(e.detail.page);
  });

  window.addEventListener('resize', function () {
    vw = window.innerWidth; vh = window.innerHeight;
    canvas.width = vw; canvas.height = vh;
    /* In orbit mode the netnodes are positioned by applyCatalogOrbit/
       applyAllItemsOrbit on rings centred at viewport-50/50; running
       layoutNodes() would re-flow them into the default right-column
       stack and explode the ring. Re-emit the orbit instead so the
       constellation re-centres on the new viewport size. */
    if (netfield.classList.contains('is-designer-orbit')) {
      if (typeof window._biosReapplyOrbit === 'function') {
        window._biosReapplyOrbit();
      }
      return;
    }
    layoutNodes();
  }, { passive: true });

  /* ── Seeded pseudo-random (consistent layout across renders) ── */
  function sRand(n) {
    var x = Math.sin(n * 127.1 + 311.7) * 43758.5453;
    return x - Math.floor(x);
  }

  /* ── Node data + DOM build ── */
  var N     = origItems.length;
  var nodes = [];

  for (var i = 0; i < N; i++) {
    var depth    = i / Math.max(N - 1, 1);             /* 0 = front, 1 = back */
    /* Bright resting opacity — barely dimmer for deeper-depth nodes
       so the photo grid reads as the centrepiece, not background. */
    var baseOp   = 0.98 - depth * 0.06;                /* 0.98 → 0.92 */
    /* Uniform size — bumped to 380px so the ASCII-rendered photos
       dominate the right column even harder. Middle pair overlap is
       absorbed by the lateral-bias offset (slot 1 leans right, slot 2
       leans left). Top + bottom slots are horizontally separated from
       the middle column so no real-overlap risk there. */
    var nodeSize = 380;
    var baseBlur = 0;   /* depth blur disabled; kept on node so .filter logic at lines 540/558 short-circuits */
    var zIdx     = Math.round(12 - depth * 10);         /* 12 → 2       */

    var origItem  = origItems[i];
    var raw       = origItem ? (origItem.dataset.images || origItem.dataset.img || '') : '';
    var imgs      = raw.indexOf('|') !== -1 ? raw.split('|').filter(Boolean) : (raw ? [raw] : []);
    var src       = imgs[0] || '';
    var isSoldOut = origItem && origItem.dataset.soldOut === 'true';

    /* outer wrapper */
    var el = document.createElement('div');
    el.className       = 'bios-netnode' + (isSoldOut ? ' is-sold-out' : '');
    el.dataset.origIdx = i;
    var _nodeOp = isSoldOut ? (baseOp * 0.55).toFixed(3) : baseOp.toFixed(3);
    /* pointer-events:auto so node hover/click works in either viewport
       half (the inverted-C layout drifts slot 0 + last into the left
       zone, which the old dual-zone code would have de-activated). */
    el.style.cssText   = 'width:' + nodeSize + 'px;height:' + nodeSize + 'px;'
                       + 'z-index:' + zIdx + ';opacity:' + _nodeOp + ';'
                       + 'pointer-events:auto;';

    /* image fill — sits underneath the ASCII layer at rest */
    var imgEl = document.createElement('div');
    imgEl.className = 'bios-netnode-img';
    if (src) imgEl.style.backgroundImage = 'url("' + src + '")';
    el.appendChild(imgEl);

    /* ASCII rendering layer — populated asynchronously by
       biosNetnodeAscii() below once the image has loaded. Shows a
       "loading…" placeholder until ready so the box isn't empty. */
    var asciiEl = document.createElement('pre');
    asciiEl.className   = 'bios-netnode-ascii';
    asciiEl.textContent = '';
    el.appendChild(asciiEl);
    if (src) biosNetnodeAscii(src, asciiEl);

    /* Simple index label — sits above the ASCII layer */
    var labelEl = document.createElement('div');
    labelEl.className   = 'bios-netnode-label';
    labelEl.textContent = '[' + String(i + 1).padStart(2, '0') + ']';
    el.appendChild(labelEl);

    netfield.appendChild(el);

    nodes.push({
      bx: 0, by: 0,                    /* base position (set by layoutNodes) */
      x:  0, y:  0,                    /* current position (base + breath)   */
      depth: depth,
      baseOp: baseOp, baseBlur: baseBlur,
      nodeSize: nodeSize, zIdx: zIdx,
      /* breathing params — unique per node */
      phY: sRand(i * 7 + 1) * Math.PI * 2,
      phX: sRand(i * 7 + 2) * Math.PI * 2,
      spY: 0.30 + sRand(i * 7 + 3) * 0.25,
      spX: 0.22 + sRand(i * 7 + 4) * 0.20,
      amY: 7  + sRand(i * 7 + 5) * 10,
      amX: 5  + sRand(i * 7 + 6) * 8,
      el: el, imgEl: imgEl, labelEl: labelEl,
      active: false, glitching: false, soldOut: isSoldOut,
      nodeOrigIdx: i,                  /* origItems index — used by hover handlers */
      /* physics */
      rx: 0, ry: 0,                   /* repulsion/magnet displacement from bx/by */
      vx: 0, vy: 0,                   /* velocity */
      trail: []                        /* recent positions — rendered during fast movement */
    });

    /* ── Hover: node glow + illuminate matching left item ──
       The _rightZone gate is gone: with the inverted-C layout, slots
       0 (top) and N-1 (bottom) drift into the LEFT half of the
       viewport. Gating hover by _rightZone meant those nodes silently
       refused mouse interactions. Now any node accepts hover/click
       wherever it sits — pointer-events stay `auto` regardless of
       which viewport half the cursor is in. */
    (function (_i, _el, _imgEl) {
      _imgEl.addEventListener('mouseenter', function () {
        if (_netScrolling) return;
        var textItem = items[MID + _i];
        if (!textItem || textItem.style.display === 'none') return;
        _nodeHoverActive = true;
        clearTimeout(_C.getIdleTimer());
        hideIdleView();
        _C.setHoverItem(textItem);
        playHoverSound();
        illuminateAt(MID + _i);
        showPreview(textItem);
        /* Visual typewriter re-enabled (user wanted only the sound
           removed — the typingTick call inside startSporadicType is
           now commented out, but the visual print stays). */
        startSporadicType(textItem);
        window._setNetActive(_i);
        var handle = textItem.dataset.handle;
        if (handle) sessionStorage.setItem('last_' + handle, String(Date.now()));
        /* Start the JS-driven ASCII decryption */
        var _ascii = _el.querySelector('.bios-netnode-ascii');
        if (_ascii) decodeStart(_ascii);
      });
      _imgEl.addEventListener('mouseleave', function () {
        if (!_nodeHoverActive) return;
        var textItem = items[MID + _i];
        if (_C.getHoverItem() !== textItem) return;
        _nodeHoverActive = false;
        _C.setHoverItem(null);
        cancelSporadicType(textItem);
        hidePreview();
        illuminateAt(_C.getActiveIdx());
        window._clearNetActive();
        clearTimeout(_C.getIdleTimer());
        _C.setIdleTimer(setTimeout(showIdleView, 2200));
        /* Restore the ASCII layer (cancels any in-flight decryption) */
        var _ascii = _el.querySelector('.bios-netnode-ascii');
        if (_ascii) decodeStop(_ascii);
      });
      /* click / dblclick stay on the full node container */
      _el.addEventListener('click', function () {
        var textItem = items[MID + _i];
        if (!textItem) return;
        if (textItem.dataset.priceCents === '999') {
          if (window._biosOpenMarket) window._biosOpenMarket(textItem.dataset.handle || '');
          return;
        }
        openOverlay(textItem);
      });
      _el.addEventListener('dblclick', function () {
        var textItem = items[MID + _i];
        if (!textItem) return;
        if (textItem.dataset.priceCents === '999') {
          if (window._biosOpenMarket) window._biosOpenMarket(textItem.dataset.handle || '');
          return;
        }
        openOverlay(textItem);
      });
    })(i, el, imgEl);
  }

  /* ── Layout: vertical scroll — newest (index 0) at top, oldest at bottom ── */
  function layoutNodes() {
    var ROW_SPACING = 320;  /* px between rows — bumped to clear larger 260px nodes */
    var RIGHT_PAD   = 60;   /* px from left/right viewport edges */
    var TOP_PAD     = 130 + Math.round(vh * 0.10); /* +10vh keeps first node clear of header+player */

    /* Looser column: pin nodes near a centre line on the right half
       with horizontal drift (±BAND px). Bumped BAND from ±90 → ±160
       so the photo grid feels organic rather than a stack, while still
       respecting the right-half boundary (right edge at vw - 190px
       for a 260px node + 60px pad, so ±160 stays clear of overflow). */
    var centreLine = vw / 2 + (vw / 2) * 0.50;            /* ~75% across viewport */
    var BAND       = Math.min(Math.round(vw * 0.10), 160); /* ±10vw, capped at 160px */
    totalHeight    = N * ROW_SPACING + TOP_PAD + RIGHT_PAD;

    /* ── Exclusion zones: avoid spawning over the music player UI or
       the right-side logstream. We read the bounding rects at layout
       time and shift any colliding node LEFT (out of the rect, keeping
       its row in place vertically). Padded by 40px so the spring/breath
       drift (±~30px in worst case) can't push a node back into the zone. */
    var EXCL_PAD = 40;
    function rectOf(el) {
      if (!el) return null;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return null;
      return { l: r.left - EXCL_PAD, r: r.right + EXCL_PAD,
               t: r.top  - EXCL_PAD, b: r.bottom + EXCL_PAD };
    }
    var exclusions = [
      rectOf(document.querySelector('.bios-top-right')),   /* player + clock */
      rectOf(document.getElementById('bios-logstream'))    /* right-side syslog */
    ].filter(Boolean);
    function avoidExclusions(bx, by, nodeSize) {
      /* Treat the node as a square centred at (bx, by). If overlap with
         any exclusion zone, shift left so the node's right edge sits
         just left of the zone's left edge. */
      var ns = nodeSize || 168;
      for (var e = 0; e < exclusions.length; e++) {
        var z = exclusions[e];
        var nodeL = bx - ns / 2;
        var nodeR = bx + ns / 2;
        var nodeT = by - ns / 2;
        var nodeB = by + ns / 2;
        if (nodeR > z.l && nodeL < z.r && nodeB > z.t && nodeT < z.b) {
          bx = z.l - ns / 2;
        }
      }
      return bx;
    }

    for (var i = 0; i < N; i++) {
      /* sRand returns 0..1; remap to -1..1 then multiply by BAND. */
      var rawX = centreLine + (sRand(i * 7 + 2) * 2 - 1) * BAND;
      var rawY = TOP_PAD + i * ROW_SPACING + (sRand(i * 7 + 3) - 0.5) * ROW_SPACING * 0.25;
      nodes[i].bx = avoidExclusions(rawX, rawY, nodes[i].nodeSize);
      nodes[i].by = rawY;
    }
    /* update spacer height so scroller content matches layout */
    spacerEl.style.height = totalHeight + 'px';
    /* apply base positions to DOM */
    nodes.forEach(function (nd) {
      var ns = nd.nodeSize;
      nd.el.style.left = Math.round(nd.bx - ns / 2) + 'px';
      nd.el.style.top  = Math.round(nd.by - ns / 2) + 'px';
      nd.x = nd.bx; nd.y = nd.by;
    });

    /* ── Clip netfield (and canvas) to the safe zone between header & footer ── */
    var _hdrEl = document.querySelector('.bios-header');
    var _ftrEl = document.querySelector('.bios-footer');
    _headerH   = _hdrEl ? Math.round(_hdrEl.getBoundingClientRect().bottom) : 0;
    _footerH   = _ftrEl ? Math.round(vh - _ftrEl.getBoundingClientRect().top) : 0;
    netfield.style.clipPath = 'inset(' + _headerH + 'px 0px ' + _footerH + 'px 0px)';
  }
  layoutNodes();

  /* ── Dual-zone mouse model ─────────────────────────────────────────────
     The viewport is split at vw/2:
       LEFT  zone (x < vw/2) — product titles are the input; nodes are passive.
       RIGHT zone (x > vw/2) — network nodes are the input; text list illuminates.
     A subtle vertical hairline appears near the midpoint to hint at the split.
     When crossing zones, any active hover state is cleanly torn down.     ── */
  var _rightZone       = false;
  var _nodeHoverActive = false;   /* true when a node (not a title) owns hoverItem */
  var zoneLineEl       = document.getElementById('bios-zone-line');
  var _cursorX         = -9999;   /* live cursor position — used by physics */
  var _cursorY         = -9999;

  document.addEventListener('mousemove', function (e) {
    _cursorX = e.clientX;
    _cursorY = e.clientY;
    var x    = e.clientX;
    var half = window.innerWidth / 2;

    /* zone line: visible within 80 px of the midpoint.
       Skip in catalog-orbit mode — the centered list sits AT 50vw so
       the zone-line shows through the first product title and the
       top-most netnode as a thin dark vertical bar. */
    if (zoneLineEl) {
      var _drumOrbit = document.getElementById('bios-drum');
      if (_drumOrbit && _drumOrbit.classList.contains('is-catalog-orbit-mode')) {
        zoneLineEl.classList.remove('is-near');
      } else {
        zoneLineEl.classList.toggle('is-near', Math.abs(x - half) < 80);
      }
    }

    var wasRight = _rightZone;
    _rightZone = x > half;

    if (_rightZone === wasRight) return; /* no zone change — nothing to do */

    if (_rightZone) {
      /* ── Entered RIGHT zone — cursor flips to pointer over nodes.
         Pointer-events stay `auto` regardless of zone now (set once at
         node creation) so left-biased inverted-C slots (top/bottom)
         remain hover/clickable wherever the cursor came from. */
      nodes.forEach(function (nd) { nd.el.style.cursor = 'pointer'; });
      /* if a text-item hover was active, tear it down cleanly */
      if (_C.getHoverItem() && !_nodeHoverActive) {
        cancelSporadicType(_C.getHoverItem());
        hidePreview();
        window._clearNetActive();
        _C.setHoverItem(null);
      }
    } else {
      /* ── Entered LEFT zone — reset cursor only (don't disable
         pointer-events, see RIGHT-zone comment above). */
      nodes.forEach(function (nd) { nd.el.style.cursor = ''; });
      /* if a node hover was active, tear it down cleanly */
      if (_nodeHoverActive) {
        if (_C.getHoverItem()) cancelSporadicType(_C.getHoverItem());
        illuminateAt(_C.getActiveIdx());
        window._clearNetActive();
        _C.setHoverItem(null);
        _nodeHoverActive = false;
        clearTimeout(_C.getIdleTimer());
        _C.setIdleTimer(setTimeout(showIdleView, 2200));
      }
    }
  }, { passive: true });

  /* ── Edge list — single linear chain, one edge per consecutive pair.
       Previously each node also had a skip-1 edge (i → i+2) plus five
       seeded long-range cross-connections, which produced ~2.2N edges
       and read as a busy web when idle. The chain alone (~N-1 edges)
       gives a clear timeline that still says "these belong together"
       without the visual clutter. */
  var edges = [];
  for (var i = 0; i < N; i++) {
    if (i + 1 < N) edges.push({ a: i, b: i + 1, long: false, off: false });
  }

  /* ── Glitch schedulers ── */
  function schedEdgeGlitch() {
    var e = edges[Math.floor(Math.random() * edges.length)];
    if (e && !e.off) {
      e.off = true;
      setTimeout(function () { e.off = false; }, 60 + Math.random() * 250);
    }
    setTimeout(schedEdgeGlitch, 80 + Math.random() * 600);
  }
  schedEdgeGlitch();

  function schedNodeGlitch() {
    /* Skip entirely while the netfield is in designer-orbit mode. In
       orbit mode the netgraph RAF (which normally restores the
       transform on the next frame) is paused, so a transform jerk
       here would never get cleared — leading to nodes "bloating" to
       full 1.0 scale (the orbit's scale() was overwritten by
       translate()). Skipping in orbit avoids the bug entirely. */
    if (netfield.classList.contains('is-designer-orbit')) {
      setTimeout(schedNodeGlitch, 800 + Math.random() * 1200);
      return;
    }
    var nd = nodes[Math.floor(Math.random() * N)];
    if (nd && !nd.active && !nd.glitching) {
      nd.glitching = true;
      /* brief brightness spike */
      nd.el.style.opacity = Math.min(1, nd.baseOp * 3.5).toFixed(3);
      /* optional: jerk position slightly */
      var jx = (Math.random() - 0.5) * 6;
      var jy = (Math.random() - 0.5) * 6;
      nd.el.style.transform = 'translate(' + jx.toFixed(1) + 'px,' + jy.toFixed(1) + 'px)';
      setTimeout(function () {
        nd.glitching = false;
        /* restore will be handled by RAF on next frame */
      }, 45 + Math.random() * 130);
    }
    setTimeout(schedNodeGlitch, 350 + Math.random() * 1400);
  }
  schedNodeGlitch();

  /* ── Image glitch scheduler — corrupt a random node's photo briefly ── */
  function schedImgGlitch() {
    var nd = nodes[Math.floor(Math.random() * N)];
    if (nd && !nd.active && nd.imgEl) {
      nd.imgEl.classList.remove('is-glitching'); /* reset if still running */
      /* force reflow so re-adding the class restarts the animation */
      void nd.imgEl.offsetWidth;
      nd.imgEl.classList.add('is-glitching');
      setTimeout(function () {
        if (nd.imgEl) nd.imgEl.classList.remove('is-glitching');
      }, 260);
    }
    setTimeout(schedImgGlitch, 1200 + Math.random() * 4000);
  }
  schedImgGlitch();

  /* ── Sold-out node corruption: erratic persistent glitch loop ── */
  (function schedSoldOutCorrupt() {
    /* Bail in designer-orbit mode — bios-designer-mode.js owns the
       opacity (set to 1 by the chain-emerge animation) and this
       sold-out flicker would override it back down to 0.01–0.07,
       making the orbit ring almost invisible. The scheduler keeps
       ticking so it resumes cleanly when the user exits orbit. */
    if (netfield.classList.contains('is-designer-orbit')) {
      setTimeout(schedSoldOutCorrupt, 600);
      return;
    }
    nodes.forEach(function(nd) {
      if (!nd.soldOut || nd.active) return;
      if (Math.random() < 0.45) {
        nd.imgEl.classList.remove('is-glitching');
        void nd.imgEl.offsetWidth;
        nd.imgEl.classList.add('is-glitching');
        setTimeout(function() {
          if (nd.imgEl) nd.imgEl.classList.remove('is-glitching');
        }, 220);
        /* brief opacity stutter on the node wrapper */
        var flickerOp = (Math.random() * 0.06 + 0.01).toFixed(3);
        nd.el.style.opacity = flickerOp;
        setTimeout(function() {
          if (!nd.active) nd.el.style.opacity = (nd.baseOp * 0.55).toFixed(3);
        }, 60 + Math.random() * 120);
      }
    });
    setTimeout(schedSoldOutCorrupt, 350 + Math.random() * 550);
  })();

  /* ── Pulse: signal dot travels along edges from activated node ── */
  var pulses = []; /* { from, to, t (0→1), wave, spd } */

  function triggerPulse(fromIdx) {
    var neighbors = [];
    edges.forEach(function (e) {
      var nei = e.a === fromIdx ? e.b : e.b === fromIdx ? e.a : -1;
      if (nei >= 0 && !e.off) {
        pulses.push({ from: fromIdx, to: nei, t: 0, wave: 1, spd: 0.022 });
        neighbors.push(nei);
      }
    });
    /* 2nd-hop wave — deferred until first pulse is midway */
    setTimeout(function () {
      neighbors.forEach(function (hopIdx) {
        edges.forEach(function (e) {
          var nei2 = e.a === hopIdx ? e.b : e.b === hopIdx ? e.a : -1;
          if (nei2 >= 0 && nei2 !== fromIdx && !e.off) {
            pulses.push({ from: hopIdx, to: nei2, t: 0, wave: 2, spd: 0.016 });
          }
        });
      });
    }, 280);
  }

  /* ── Glitch cascade: lowkey corruption ripple to immediate neighbours ── */
  function cascadeGlitch(fromIdx) {
    edges.forEach(function (e) {
      var nei = e.a === fromIdx ? e.b : e.b === fromIdx ? e.a : -1;
      if (nei < 0) return;
      var nd = nodes[nei];
      setTimeout(function () {
        if (nd.glitching || nd.active) return;
        nd.glitching = true;
        nd.el.style.opacity = Math.min(1, nd.baseOp * 2.0).toFixed(3);
        setTimeout(function () { nd.glitching = false; }, 55 + Math.random() * 65);
      }, 90 + Math.random() * 140);
    });
  }

  /* ── Scroll wave: radial impulse from drum-scroll origin ── */
  window._netScrollWave = function (origIdx) {
    if (origIdx < 0 || origIdx >= N) return;
    var cx = nodes[origIdx].bx, cy = nodes[origIdx].by;
    nodes.forEach(function (nd, i) {
      if (i === origIdx) return;
      var dx = nd.bx - cx, dy = nd.by - cy;
      var dist = Math.sqrt(dx*dx + dy*dy) || 1;
      if (dist > 900) return;
      var str = 16 * Math.pow(1 - dist / 900, 2);
      nd.vx += (dx / dist) * str;
      nd.vy += (dy / dist) * str;
    });
  };

  /* ── Active state ── */
  window._setNetActive = function (origIdx) {
    nodes.forEach(function (nd, i) {
      var wasActive = nd.active;
      nd.active = (i === origIdx);
      if (nd.active !== wasActive) {
        if (nd.active) {
          nd.el.style.opacity  = '1';
          nd.el.style.filter   = 'none';
          nd.el.style.zIndex   = '50';
          nd.imgEl.style.opacity = '0.88';
          nd.imgEl.style.filter  = 'grayscale(0.05) brightness(0.85)';
          nd.labelEl.style.color = 'rgba(210,195,145,0.95)';
        } else {
          nd.el.style.opacity  = nd.baseOp.toFixed(3);
          nd.el.style.filter   = nd.baseBlur > 0 ? 'blur(' + nd.baseBlur.toFixed(1) + 'px)' : '';
          nd.el.style.zIndex   = nd.zIdx;
          nd.imgEl.style.opacity = '';
          nd.imgEl.style.filter  = '';
          nd.labelEl.style.color = '';
        }
      }
    });
    /* fire pulse + cascade on activation */
    triggerPulse(origIdx);
    cascadeGlitch(origIdx);
  };

  window._clearNetActive = function () {
    nodes.forEach(function (nd) {
      if (!nd.active) return;
      nd.active = false;
      nd.el.style.opacity  = nd.baseOp.toFixed(3);
      nd.el.style.filter   = nd.baseBlur > 0 ? 'blur(' + nd.baseBlur.toFixed(1) + 'px)' : '';
      nd.el.style.zIndex   = nd.zIdx;
      nd.imgEl.style.opacity = '';
      nd.imgEl.style.filter  = '';
      nd.labelEl.style.color = '';
    });
  };

  /* ── RAF animation loop — physics + edges + pulses ── */
  var t0 = performance.now();

  /* physics constants */
  var REPULSE_R   = 240;   /* cursor repulsion radius (px) */
  var REPULSE_STR = 0.60;  /* repulsion impulse per frame */
  var MAGNET_STR  = 0.14;  /* magnetic pull toward cursor for active node */
  var MAX_PULL    = 80;    /* max magnetic displacement (px) */
  var DAMPING     = 0.80;  /* velocity damping per frame */
  var SPRING_K    = 0.10;  /* spring constant pulling rx/ry back to 0 */

  function drawCanvas(scrollTop) {
    ctx.clearRect(0, 0, vw, vh);

    ctx.save();
    /* clip canvas lines/pulses to the safe zone between header and footer */
    ctx.beginPath();
    ctx.rect(0, _headerH, vw, Math.max(0, vh - _headerH - _footerH));
    ctx.clip();
    ctx.translate(0, -scrollTop);

    /* ── Motion trails — painted first, behind everything ── */
    nodes.forEach(function (nd) {
      if (!nd.trail || nd.trail.length < 2) return;
      nd.trail.forEach(function (pos, ti) {
        var frac  = (ti + 1) / nd.trail.length;
        var alpha = frac * 0.028 * (nd.active ? 2.0 : 1);
        if (alpha < 0.004) return;
        var ns = nd.nodeSize; /* trail rectangle matches node size; no active-scale */
        ctx.fillStyle = 'rgba(128,128,128,' + alpha.toFixed(3) + ')';
        ctx.fillRect(Math.round(pos.x - ns / 2), Math.round(pos.y - ns / 2), ns, ns);
      });
    });

    /* scanline static */
    if (Math.random() < 0.06) {
      for (var s = 0; s < 2; s++) {
        var sy = Math.floor(Math.random() * vh);
        ctx.fillStyle = 'rgba(155,155,155,0.018)';
        ctx.fillRect(0, sy, vw, 1);
      }
    }

    /* ── Detect active node for edge highlighting ── */
    var activeNodeIdx = -1;
    nodes.forEach(function (nd, ni) { if (nd.active) activeNodeIdx = ni; });

    /* ── Static list-neighbour edges (highlighted/dimmed by active node) ── */
    edges.forEach(function (e) {
      if (e.off) return;
      var nA = nodes[e.a], nB = nodes[e.b];
      var depthAvg   = (nA.depth + nB.depth) * 0.5;
      var baseAlpha  = e.long ? (0.04 - depthAvg * 0.03) : (0.11 - depthAvg * 0.09);
      if (baseAlpha <= 0) return;

      var isConnected = activeNodeIdx >= 0 && (e.a === activeNodeIdx || e.b === activeNodeIdx);
      var isDimmed    = activeNodeIdx >= 0 && !isConnected;

      var alpha = isDimmed    ? baseAlpha * 0.35
                : isConnected ? Math.min(0.30, baseAlpha * 3.0)
                : baseAlpha;
      var color = isConnected ? '160,160,160' : '120,120,120';
      var width = isConnected ? (e.long ? 0.7 : Math.max(0.6, 1.4 - depthAvg * 1.0))
                              : e.long ? (isDimmed ? 0.25 : 0.4)
                              : (1.2 - depthAvg * 0.8) * (isDimmed ? 0.6 : 1.0);

      ctx.beginPath();
      ctx.moveTo(nA.x, nA.y);
      ctx.lineTo(nB.x, nB.y);
      ctx.strokeStyle = 'rgba(' + color + ',' + alpha.toFixed(3) + ')';
      ctx.lineWidth   = width;
      ctx.stroke();
    });

    /* ── Dynamic proximity edges — rewire around cursor ── */
    var PROX_R = 300, LINK_R = 430;
    for (var a = 0; a < N; a++) {
      var nA = nodes[a];
      var dax = nA.x - _cursorX, day = nA.y - _cursorY;
      var dA = Math.sqrt(dax*dax + day*day);
      if (dA >= PROX_R) continue;
      for (var b = a + 1; b < N; b++) {
        var nB = nodes[b];
        var dbx = nB.x - _cursorX, dby = nB.y - _cursorY;
        var dB = Math.sqrt(dbx*dbx + dby*dby);
        if (dB >= PROX_R) continue;
        var abx = nB.x - nA.x, aby = nB.y - nA.y;
        if (Math.sqrt(abx*abx + aby*aby) > LINK_R) continue;
        var alpha = (1 - dA/PROX_R) * (1 - dB/PROX_R) * 0.22;
        ctx.beginPath();
        ctx.moveTo(nA.x, nA.y);
        ctx.lineTo(nB.x, nB.y);
        ctx.strokeStyle = 'rgba(130,130,130,' + alpha.toFixed(3) + ')';
        ctx.lineWidth = 0.55;
        ctx.stroke();
      }
    }

    /* ── Propagation pulse dots ── */
    pulses.forEach(function (p) {
      var nA = nodes[p.from], nB = nodes[p.to];
      var px = nA.x + (nB.x - nA.x) * p.t;
      var py = nA.y + (nB.y - nA.y) * p.t;
      var alpha = (1 - p.t) * (p.wave === 1 ? 0.88 : 0.45);
      ctx.beginPath();
      ctx.arc(px, py, p.wave === 1 ? 1.2 : 0.8, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(155,155,155,' + alpha.toFixed(3) + ')';
      ctx.fill();
    });

    ctx.restore();
  }

  /* Tracks whether the canvas was wiped while in orbit mode. Without
     this flag, the last frame drawn before orbit started (with all
     connecting lines + propagation pulses) stays burned onto the
     canvas as static residue, visible in the gaps between netnodes.
     We clear once on entry, then keep skipping draws while in orbit. */
  var _canvasClearedInOrbit = false;

  (function loop(ts) {
    /* When designer-orbit mode is active, bios-designer-mode.js is positioning
       matching nodes manually in a circular constellation. Skip the per-frame
       breath/cursor/spring math so our manual transforms aren't fought over
       every frame. The RAF stays scheduled so we resume cleanly on exit. */
    if (netfield.classList.contains('is-designer-orbit')) {
      if (!_canvasClearedInOrbit) {
        /* Wipe stale lines/pulses from the last pre-orbit frame. */
        ctx.clearRect(0, 0, vw, vh);
        if (typeof satCtx !== 'undefined' && satCtx && satCanvas) {
          satCtx.clearRect(0, 0, satCanvas.width, satCanvas.height);
        }
        _canvasClearedInOrbit = true;
      }
      requestAnimationFrame(loop);
      return;
    }
    /* Reset the flag whenever we re-enter the normal draw path. */
    _canvasClearedInOrbit = false;
    var t = (ts - t0) * 0.001;
    var scrollTop = scrollerEl.scrollTop;

    nodes.forEach(function (nd) {
      var breathDx = Math.cos(t * nd.spX + nd.phX) * nd.amX;
      var breathDy = Math.sin(t * nd.spY + nd.phY) * nd.amY;

      if (!nd.active) {
        /* ── Cursor repulsion (right zone, nodes push away) ── */
        var cdx = nd.bx - _cursorX, cdy = nd.by - _cursorY;
        var cdist = Math.sqrt(cdx*cdx + cdy*cdy) || 1;
        if (_rightZone && cdist < REPULSE_R) {
          var f = REPULSE_STR * Math.pow(1 - cdist / REPULSE_R, 2);
          nd.vx += (cdx / cdist) * f;
          nd.vy += (cdy / cdist) * f;
        }
      } else {
        /* ── Magnetic pull toward cursor (active node drifts to you) ── */
        var mdx = _cursorX - nd.bx, mdy = _cursorY - nd.by;
        var mdist = Math.sqrt(mdx*mdx + mdy*mdy) || 1;
        var pull = Math.min(mdist, MAX_PULL) / MAX_PULL;
        nd.vx += (mdx / mdist) * MAGNET_STR * pull;
        nd.vy += (mdy / mdist) * MAGNET_STR * pull;
      }

      /* spring return + damping */
      nd.vx += -SPRING_K * nd.rx;
      nd.vy += -SPRING_K * nd.ry;
      nd.vx *= DAMPING;
      nd.vy *= DAMPING;
      nd.rx += nd.vx;
      nd.ry += nd.vy;

      nd.x = nd.bx + breathDx + nd.rx;
      nd.y = nd.by + breathDy + nd.ry;

      /* ── Clip-boundary crossing glitch ── */
      var _screenCY = nd.by + nd.ry - scrollTop;
      var _nowVis   = _screenCY > _headerH && _screenCY < (vh - _footerH);
      if (typeof nd._wasVisible === 'undefined') nd._wasVisible = _nowVis;
      if (_nowVis !== nd._wasVisible && !nd._glitchCooldown) {
        nd._wasVisible    = _nowVis;
        nd._glitchCooldown = true;
        triggerBoundaryGlitch(nd);
        (function (_n) { setTimeout(function () { _n._glitchCooldown = false; }, 450); })(nd);
      }

      /* trail: grow when fast (scroll wave impulse), drain when slowing */
      var _spd = Math.sqrt(nd.vx * nd.vx + nd.vy * nd.vy);
      if (_spd > 0.9) {
        nd.trail.push({ x: nd.x, y: nd.y });
        if (nd.trail.length > 3) nd.trail.shift();
      } else if (nd.trail.length > 0) {
        nd.trail.shift();
      }

      if (!nd.glitching) {
        /* Active scale removed — hovering a node no longer scales it
           up to 1.22×. The CSS ASCII-decode animation on hover is the
           sole "this item is being inspected" signal now, which keeps
           the layout grid stable and reads as decoding rather than
           focus-magnifying. */
        nd.el.style.transform = 'translate(' + (breathDx + nd.rx).toFixed(1) + 'px,'
                              + (breathDy + nd.ry - scrollTop).toFixed(1) + 'px)';
      }
    });

    /* advance + prune pulses */
    for (var pi = pulses.length - 1; pi >= 0; pi--) {
      pulses[pi].t += pulses[pi].spd;
      if (pulses[pi].t >= 1) pulses.splice(pi, 1);
    }

    drawCanvas(scrollTop);
    requestAnimationFrame(loop);
  })(t0);

  /* ── Scroll-to by index: called by left-side sync ── */
  /* smooth=true: animate over 140ms matching .bios-list transition so both panels move together */
  window._netScrollToIdx = function (origIdx, smooth) {
    if (!scrollerEl || origIdx < 0 || origIdx >= N) return;
    var targetY = Math.max(0, nodes[origIdx].by - vh * 0.35);
    _markScrolling();

    /* cancel any in-flight animation */
    if (_netScrollRafId) { cancelAnimationFrame(_netScrollRafId); _netScrollRafId = null; }

    if (smooth) {
      var startY   = scrollerEl.scrollTop;
      var diff     = targetY - startY;
      if (Math.abs(diff) < 2) return;
      var startT   = null;
      var DURATION = 140; /* matches .bios-list transition: 0.14s */
      /* approximate cubic-bezier(0.25, 0.46, 0.45, 0.94) with an ease-out power curve */
      function _easeOut(t) { return 1 - Math.pow(1 - t, 2.4); }
      (function step(ts) {
        if (startT === null) startT = ts;
        var progress = Math.min((ts - startT) / DURATION, 1);
        scrollerEl.scrollTop = startY + diff * _easeOut(progress);
        if (progress < 1) {
          _netScrollRafId = requestAnimationFrame(step);
        } else {
          _netScrollRafId = null;
        }
      })(performance.now());
    } else {
      scrollerEl.scrollTop = targetY;
    }
  };

  /* ── Overlay satellite nodes ─────────────────────────────────────────────
     When the product overlay opens, nearest catalogue neighbours appear as
     small glowing nodes in the dark backdrop around the dialog.  Each node
     breathes, wires run back to the dialog edge with occasional flicker,
     hover reveals the product image + name, click swaps to that item.    ── */

  var satCanvas = document.getElementById('bios-sat-canvas');
  var satField  = document.getElementById('bios-sat-field');
  var satCtx    = satCanvas ? satCanvas.getContext('2d') : null;
  var satData   = [];
  var satRafId  = null;

  /* Separate seed function so satellite randoms don't collide with main sRand */
  function sRandS(n) {
    var x = Math.sin(n * 211.3 + 91.7) * 43758.5453;
    return x - Math.floor(x);
  }

  /* Point on the overlay-inner boundary where a wire from (scx,scy) terminates */
  function rectEdge(scx, scy, rect) {
    var rcx = (rect.left + rect.right)  * 0.5;
    var rcy = (rect.top  + rect.bottom) * 0.5;
    var dx  = scx - rcx, dy = scy - rcy;
    if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return { x: rcx, y: rcy };
    var hw  = (rect.right  - rect.left) * 0.5;
    var hh  = (rect.bottom - rect.top)  * 0.5;
    var t   = Math.min(hw / Math.abs(dx), hh / Math.abs(dy));
    return { x: rcx + dx * t, y: rcy + dy * t };
  }

  window._biosClearSatellites = function () {
    if (satRafId) { cancelAnimationFrame(satRafId); satRafId = null; }
    satData.forEach(function (s) {
      if (s.el && s.el.parentNode) s.el.parentNode.removeChild(s.el);
    });
    satData = [];
    if (satCtx && satCanvas) satCtx.clearRect(0, 0, satCanvas.width, satCanvas.height);
  };

  window._biosUpdateSatellites = function (activeItem) {
    window._biosClearSatellites();
    if (!satCanvas || !satField || !satCtx || !activeItem) return;

    /* Resolve origIdx from item's data-idx (tripled array position) */
    var rawIdx  = parseInt(activeItem.dataset.idx, 10);
    var origIdx = isNaN(rawIdx) ? 0 : Math.max(0, Math.min(N - 1, rawIdx - MID));

    /* Pick up to 5 nearest neighbours (wrapping around catalogue) */
    var neighborIdxs = [];
    var seen = {}; seen[origIdx] = true;
    [-1, 1, -2, 2, -3].forEach(function (d) {
      var ni = ((origIdx + d) % N + N) % N;
      if (!seen[ni]) { seen[ni] = true; neighborIdxs.push(ni); }
    });
    neighborIdxs = neighborIdxs.slice(0, 5);

    /* Size canvas to full viewport */
    var vw = window.innerWidth, vh = window.innerHeight;
    satCanvas.width  = vw;
    satCanvas.height = vh;

    /* Measure overlay-inner after its layout is settled */
    var innerEl  = document.getElementById('bios-overlay-inner');
    var ir = innerEl ? innerEl.getBoundingClientRect()
                     : { left: vw * 0.04, top: vh * 0.06, right: vw * 0.96, bottom: vh * 0.94 };

    var SAT = 120;  /* node square size (px) */
    var PAD = 26;   /* minimum gap from viewport edge or dialog */

    /* Compute available strip widths/heights around the dialog */
    var leftW  = ir.left   - PAD;
    var rightW = vw - ir.right  - PAD;
    var topH   = ir.top    - PAD;
    var botH   = vh - ir.bottom - PAD;

    function pickPos(ni, slotIdx) {
      /* Build list of zones that have room for a node */
      var zones = [];
      if (leftW  > SAT + 10) zones.push(0);
      if (rightW > SAT + 10) zones.push(1);
      if (topH   > SAT + 10) zones.push(2);
      if (botH   > SAT + 10) zones.push(3);
      if (!zones.length) zones = [0, 1];   /* fallback — overlap the backdrop edges */

      /* Alternate zones so siblings don't cluster */
      var zone = zones[slotIdx % zones.length];
      var bx, by, room;

      if (zone === 0) {          /* left strip */
        room = Math.max(0, leftW  - SAT - PAD);
        bx   = PAD + SAT / 2 + sRandS(ni * 7 + 1) * room;
        by   = PAD + SAT / 2 + sRandS(ni * 7 + 2) * Math.max(0, vh - SAT - PAD * 2);
      } else if (zone === 1) {   /* right strip */
        room = Math.max(0, rightW - SAT - PAD);
        bx   = ir.right + PAD + SAT / 2 + sRandS(ni * 7 + 3) * room;
        by   = PAD + SAT / 2 + sRandS(ni * 7 + 4) * Math.max(0, vh - SAT - PAD * 2);
      } else if (zone === 2) {   /* top band */
        room = Math.max(0, topH  - SAT - PAD);
        bx   = PAD + SAT / 2 + sRandS(ni * 7 + 5) * Math.max(0, vw - SAT - PAD * 2);
        by   = PAD + SAT / 2 + sRandS(ni * 7 + 6) * room;
      } else {                   /* bottom band */
        room = Math.max(0, botH  - SAT - PAD);
        bx   = PAD + SAT / 2 + sRandS(ni * 7 + 7) * Math.max(0, vw - SAT - PAD * 2);
        by   = ir.bottom + PAD + SAT / 2 + sRandS(ni * 7 + 8) * room;
      }
      return {
        bx: Math.max(SAT / 2 + 4, Math.min(vw - SAT / 2 - 4, bx)),
        by: Math.max(SAT / 2 + 4, Math.min(vh - SAT / 2 - 4, by))
      };
    }

    /* Build one satellite DOM node per neighbour */
    neighborIdxs.forEach(function (ni, slotIdx) {
      var origItem = origItems[ni];
      var textItem = items[MID + ni];
      if (!origItem || !textItem) return;

      var raw  = origItem.dataset.images || origItem.dataset.img || '';
      var imgs = raw.indexOf('|') !== -1 ? raw.split('|').filter(Boolean) : (raw ? [raw] : []);
      var src  = imgs[0] || '';
      var name = origItem.dataset.name || '';

      var pos = pickPos(ni, slotIdx);

      var el = document.createElement('div');
      el.className = 'bios-satnode';
      el.style.width  = SAT + 'px';
      el.style.height = SAT + 'px';
      el.style.left   = Math.round(pos.bx - SAT / 2) + 'px';
      el.style.top    = Math.round(pos.by - SAT / 2) + 'px';

      /* product image (ghostly by default, vivid on hover via CSS) */
      var imgEl = document.createElement('div');
      imgEl.className = 'bios-satnode-img';
      if (src) imgEl.style.backgroundImage = 'url("' + src + '")';
      el.appendChild(imgEl);

      /* hover tooltip — product name */
      if (name) {
        var nameEl = document.createElement('div');
        nameEl.className   = 'bios-satnode-name';
        nameEl.textContent = name;
        el.appendChild(nameEl);
      }

      /* index badge */
      var idxEl = document.createElement('div');
      idxEl.className   = 'bios-satnode-label';
      idxEl.textContent = '[' + String(ni + 1).padStart(2, '0') + ']';
      el.appendChild(idxEl);

      /* click → swap overlay to this product */
      el.addEventListener('click', function () { openOverlay(textItem); });

      satField.appendChild(el);

      /* staggered fade-in */
      setTimeout(function () { el.classList.add('is-visible'); }, 60 + slotIdx * 80);

      satData.push({
        el:       el,
        bx:       pos.bx, by:  pos.by,
        phX:      sRandS(ni * 9 + 1) * Math.PI * 2,
        phY:      sRandS(ni * 9 + 2) * Math.PI * 2,
        spX:      0.15 + sRandS(ni * 9 + 3) * 0.14,
        spY:      0.19 + sRandS(ni * 9 + 4) * 0.16,
        amX:      7 + sRandS(ni * 9 + 5) * 10,
        amY:      6 + sRandS(ni * 9 + 6) * 9,
        wireOff:  false,
        glitching: false,
        /* signal pulse: dot travels dialog-edge → satellite on a loop */
        pulseT:   sRandS(ni * 9 + 7),            /* random start phase 0–1 */
        pulseSpd: 0.004 + sRandS(ni * 9 + 8) * 0.004  /* travel speed per frame */
      });
    });

    if (!satData.length) return;

    /* Wire flicker scheduler */
    function schedSatWireGlitch() {
      if (!satRafId) return;
      var s = satData[Math.floor(Math.random() * satData.length)];
      if (s) {
        s.wireOff = true;
        setTimeout(function () { if (s) s.wireOff = false; }, 45 + Math.random() * 200);
      }
      setTimeout(schedSatWireGlitch, 150 + Math.random() * 900);
    }
    schedSatWireGlitch();

    /* Node opacity glitch scheduler */
    function schedSatNodeGlitch() {
      if (!satRafId) return;
      var s = satData[Math.floor(Math.random() * satData.length)];
      if (s && !s.glitching) {
        s.glitching = true;
        s.el.style.opacity = (0.25 + Math.random() * 0.55).toFixed(2);
        setTimeout(function () {
          if (s) { s.el.style.opacity = ''; s.glitching = false; }
        }, 40 + Math.random() * 120);
      }
      setTimeout(schedSatNodeGlitch, 600 + Math.random() * 3000);
    }
    schedSatNodeGlitch();

    /* RAF animation — breathing drift + wire drawing */
    var satT0 = performance.now();

    (function satLoop(ts) {
      var t = (ts - satT0) * 0.001;
      satCtx.clearRect(0, 0, vw, vh);

      /* re-measure dialog rect each frame (stable once open) */
      var ir2 = innerEl ? innerEl.getBoundingClientRect() : ir;

      satData.forEach(function (s) {
        var dx = Math.cos(t * s.spX + s.phX) * s.amX;
        var dy = Math.sin(t * s.spY + s.phY) * s.amY;
        var cx = s.bx + dx;
        var cy = s.by + dy;

        /* drift the DOM node */
        if (!s.glitching) {
          s.el.style.transform = 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)';
        }

        /* draw wire + endpoint dots + signal pulse */
        if (!s.wireOff) {
          var ep = rectEdge(cx, cy, ir2);

          satCtx.beginPath();
          satCtx.moveTo(cx, cy);
          satCtx.lineTo(ep.x, ep.y);
          satCtx.strokeStyle = 'rgba(95, 95, 95, 0.18)';
          satCtx.lineWidth   = 0.65;
          satCtx.stroke();

          /* dot at satellite centre */
          satCtx.beginPath();
          satCtx.arc(cx, cy, 2.2, 0, Math.PI * 2);
          satCtx.fillStyle = 'rgba(128, 128, 128, 0.42)';
          satCtx.fill();

          /* dot at dialog-edge anchor */
          satCtx.beginPath();
          satCtx.arc(ep.x, ep.y, 1.5, 0, Math.PI * 2);
          satCtx.fillStyle = 'rgba(105, 105, 105, 0.28)';
          satCtx.fill();

          /* ── Signal pulse: travels from dialog edge toward satellite ── */
          s.pulseT += s.pulseSpd;
          if (s.pulseT > 1) s.pulseT -= 1;
          /* ease in/out so it fades at both ends */
          var pAlpha = Math.sin(s.pulseT * Math.PI) * 0.72;
          var ppx = ep.x + (cx - ep.x) * s.pulseT;
          var ppy = ep.y + (cy - ep.y) * s.pulseT;
          satCtx.beginPath();
          satCtx.arc(ppx, ppy, 2.0, 0, Math.PI * 2);
          satCtx.fillStyle = 'rgba(165, 165, 165, ' + pAlpha.toFixed(3) + ')';
          satCtx.fill();
        }
      });

      satRafId = requestAnimationFrame(satLoop);
    })(satT0);
  };
};
